import { Route, Routes } from 'react-router-dom';

import DictionaryPage from './dictionary-page';

export default function DictionaryRouter() {
    return (
        <Routes>
            <Route
                path="/"
                element={<DictionaryPage />}
            />
        </Routes>
    );
}